<template>
    <section
        role="region"
        aria-label="Dashboard retirement notice"
        class="relative z-10 mb-8 rounded-lg border-2 border-amber-400 bg-amber-50 p-5"
    >
        <p class="text-xs font-semibold uppercase tracking-wider text-amber-800">This dashboard is shutting down soon</p>
        <h2 class="mt-1 text-xl font-bold leading-snug text-slate-800">Streamforge has moved to app.streamforge.com</h2>
        <p class="mt-2 text-sm text-slate-700">Sign in to the new dashboard with your same email and password.</p>
        <a
            :href="NEW_DASHBOARD_URL"
            class="btn mt-4 w-full bg-indigo-500 text-white hover:bg-indigo-600"
            @click="trackClick('button')"
        >
            Go to the new dashboard &rarr;
        </a>
        <p class="mt-3 text-xs text-slate-600">
            Can't sign in there? Email
            <a :href="`mailto:${SUPPORT_EMAIL}`" class="font-medium underline hover:no-underline" @click="trackClick('email')">
                {{ SUPPORT_EMAIL }}</a
            >.
        </p>
    </section>
</template>

<script setup>
import { AnalyticalEvents, trackEvent } from '@/utils/analytics'
import { NEW_DASHBOARD_URL, SUPPORT_EMAIL } from '@/utils/legacyRetirement'

const trackClick = (target) => {
    trackEvent(AnalyticalEvents.LegacyRetirementLoginNoticeClicked, { target })
}
</script>
